module.exports = __webpack_public_path__ + "img/birthday_ribbon.06377373.svg";